import React from 'react';

/**
 * Ambient mesh-gradient background: three slow-drifting color blobs behind
 * a subtle grain veil. Pure CSS (no canvas, no backdrop-filter) so it costs
 * almost nothing — the glass surfaces above it do the blurring.
 */
const AnimatedBackground: React.FC = () => {
  return (
    <div aria-hidden className="fixed inset-0 -z-10 overflow-hidden">
      <div
        className="absolute -top-1/4 -left-1/4 h-[70vmax] w-[70vmax] rounded-full opacity-25 blur-[80px] animate-blob-a"
        style={{
          background:
            'radial-gradient(circle at 30% 30%, var(--accent), transparent 65%)',
        }}
      />
      <div
        className="absolute -bottom-1/3 -right-1/4 h-[65vmax] w-[65vmax] rounded-full opacity-20 blur-[80px] animate-blob-b"
        style={{
          background:
            'radial-gradient(circle at 60% 40%, var(--accent-2), transparent 65%)',
        }}
      />
      <div
        className="absolute top-1/3 left-1/2 h-[50vmax] w-[50vmax] rounded-full opacity-15 blur-[80px] animate-blob-c"
        style={{
          background:
            'radial-gradient(circle at 50% 50%, var(--accent-3), transparent 65%)',
        }}
      />
    </div>
  );
};

export default AnimatedBackground;
